const getModifiedData = ({ data, url, modifyResult }) => (
  typeof modifyResult === 'function' ? modifyResult(data, url) : data
)


export default getModifiedData
